module.exports = __webpack_public_path__ + "static/img/Ian-Paterson.3e6eb7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ian-Paterson.jpg
// module id = 1EHB
// module chunks = 1